import React, { useState, useEffect } from "react";
import api from "../Utils/api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const Profile = () => {
  const user = useSelector((state) => state.user.user);

  const [activeTab, setActiveTab] = useState("profile");
  const [formData, setFormData] = useState({
    _id: "",
    preferredName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dateOfBirth: "",
    pronouns: "",
    gender: "",

    address: "",
    city: "",
    country: "",
    postcode: "",

    emergencyContactName: "",
    emergencyContactNumber: "",

    twoFactor: false,
  });

  useEffect(() => {
    if (user?._id !== undefined) {
      getUserProfile();
    }
  }, [user]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const getUserProfile = async () => {
    const res = await api.get(`/user/${user._id}`);
    if (res.data.success) {
      setFormData((prevData) => ({ ...prevData, ...res.data.user }));
    } else {
      toast.error("Failed to fetch user profile");
    }
  };

  // TODO Change Avatar
  const [avatar, setAvatar] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can handle the form submission, e.g., send the avatar to your server
  };

  const updateProfile = async () => {
    // Validate form data
    if (
      !formData.preferredName ||
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.phone ||
      !formData.pronouns ||
      !formData.gender
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    const res = await api.post(`/user/update`, {
      _id: formData._id,
      updatedData: formData,
    });

    if (res.data.success) {
      getUserProfile();
      toast.success("Profile updated successfully");
    } else {
      toast.error("Failed to update profile");
    }
  };

  const tabs = [
    { id: "profile", label: "Profile" },
    { id: "profile_photo", label: "Profile Photo" },
    { id: "address", label: "Address" },
    { id: "emergency_contact", label: "Emergency Contact" },
    // { id: "security", label: "Security" },
  ];
  return (
    <div className="mt-20 mx-20 pt-6 px-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-semibold">Your Profile</h1>
        <button
          onClick={updateProfile}
          className="bg-gray-600 text-white rounded px-4 py-2 font-medium shadow hover:bg-gray-700"
        >
          Update
        </button>
      </div>
      <hr className="mt-4 mb-4" />
      <div className="flex flex-wrap gap-24">
        <ul className="min-w-[230px] min-h-[60vh] bg-gray-100 inline-block py-5">
          {tabs.map((tab) => (
            <li
              key={tab.id}
              className={`tab flex items-center text-sm font-medium hover:text-gray-700 py-5 px-5 cursor-pointer transition-all ${
                activeTab === tab.id
                  ? "bg-white text-gray-700 border-l-4 border-gray-500"
                  : "text-slate-900"
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </li>
          ))}
        </ul>

        <div className="min-w-50vw bg-white p-6 flex-1">
          {activeTab === "profile" && (
            <div className="tab-content w-full mt-8 flex gap-24">
              <div className="mt-4 w-full">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Preferred Full Name
                  </label>
                  <input
                    type="text"
                    name="perferredName"
                    value={formData.preferredName}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your preferred full name"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    First Name
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your first name"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your last name"
                  />
                </div>
              </div>
              <div className="mt-4 w-full">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Email
                  </label>
                  <input
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your username"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your phone"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Gender
                  </label>
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2 bg-white"
                  >
                    <option value="">Select your gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="non-binary">Non-binary</option>
                    <option value="prefer-not-to-say">Prefer not to say</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Pronouns
                  </label>
                  <select
                    name="pronouns"
                    value={formData.pronouns}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2 bg-white"
                  >
                    <option value="">Select your pronouns</option>
                    <option value="he/him">He/Him</option>
                    <option value="she/her">She/Her</option>
                    <option value="they/them">They/Them</option>
                    <option value="prefer-not-to-say">Prefer not to say</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
            </div>
          )}
          {activeTab === "profile_photo" && (
            <div className="w-full p-6 bg-white">
              <h2 className="text-2xl font-semibold mb-6">
                Update Profile Avatar
              </h2>
              <p className="text-sm">
                Change your profile picture, or import your current Facebook or
                Google photo.
              </p>
              <hr className="mt-4 mb-4" />
              <form
                onSubmit={handleSubmit}
                className="flex flex-col items-start"
              >
                <div className="mb-4 flex items-end">
                  {preview ? (
                    <img
                      src={preview}
                      alt="Avatar Preview"
                      className="w-32 h-32 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-32 h-32 rounded-full border border-gray-300 flex items-center justify-center bg-gray-100">
                      <span className="text-gray-400">No Image</span>
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="mt-2 ml-16 text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-gray-500 file:text-white hover:file:bg-gray-600 transition"
                  />
                </div>
              </form>
            </div>
          )}
          {activeTab === "address" && (
            <div className="tab-content max-w-2xl mt-8">
              <form className="mt-4">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Address
                  </label>
                  <input
                    type="text"
                    name="Address"
                    value={formData.address}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your preferred full name"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    City
                  </label>
                  <input
                    type="text"
                    name="City"
                    value={formData.city}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your first name"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Post Code
                  </label>
                  <input
                    type="text"
                    name="postCode"
                    value={formData.postcode}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your last name"
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Country
                  </label>
                  <select
                    name="country"
                    value={formData.country}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2 bg-white"
                  >
                    <option value="">Select your Country</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="non-binary">Non-binary</option>
                    <option value="prefer-not-to-say">Prefer not to say</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </form>
            </div>
          )}
          {activeTab === "emergency_contact" && (
            <div className="tab-content max-w-2xl mt-8">
              <form className="mt-4">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Emergency Contact Name
                  </label>
                  <input
                    type="text"
                    name="Emergency Contact Name"
                    value={formData.emergencyContactName}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your emergency contact name"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-slate-700">
                    Emergency Contact Number
                  </label>
                  <input
                    type="text"
                    name="Emergency Contact Number"
                    value={formData.emergencyContactNumber}
                    onChange={handleInputChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                    placeholder="Enter your emergency contact number"
                  />
                </div>
              </form>
            </div>
          )}

          {activeTab === "security" && (
            <div className="tab-content max-w-2xl mt-8">
              <h2 className="text-lg text-grey-400 font-semibold text-24">
                Reset Password
              </h2>
              <button className="bg-gray-400 text-white rounded px-4 py-2 mt-4 font-medium shadow hover:bg-gray-700">
                Reset
              </button>
              <hr className="mt-4 mb-2" />
              <h2 className="text-lg font-semibold text-24">
                Two Factor Authentication - Disabled
              </h2>
              <button
                disabled={!formData.twoFactor}
                className={`${
                  formData.twoFactor
                    ? "bg-green-600 hover:bg-green-700"
                    : "bg-gray-600"
                } text-white rounded px-4 py-2 mt-4 font-medium shadow `}
              >
                Enable Two Factor Authentication
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
